export enum Pages {
  Login = 'page::login',
  Home = 'page::home',
  CheckIn = 'page::checkIn',
  End = 'page::end',
  NotFound = 'page::not-found',
  Safety = 'page::safety',
  Result = 'page::result',
};
